import React from 'react'

// CardCurrencySupportedCountries returns a list of supported presentment countries for ACDC.
// CardCurrencySupportedCountries takes no input.
// This is a standalone object.
// The countries array passes a collection of country names and the matching country codes.
// code.value passes a 2-character country code.
// country.value passes the country name.

const CardCurrencySupportedCountries = () => {
  const countries = [
    { code: { value: 'AU' }, country: { value: 'Australia' } },
    { code: { value: 'BG' }, country: { value: 'Bulgaria' } },
    { code: { value: 'CA' }, country: { value: 'Canada' } },
    { code: { value: 'CY' }, country: { value: 'Cyprus' } },
    { code: { value: 'CZ' }, country: { value: 'Czech Republic' } },
    { code: { value: 'DK' }, country: { value: 'Denmark' } },
    { code: { value: 'EE' }, country: { value: 'Estonia' } },
    { code: { value: 'FI' }, country: { value: 'Finland' } },
    { code: { value: 'FR' }, country: { value: 'France' } },
    { code: { value: 'DE' }, country: { value: 'Germany' } },
    { code: { value: 'GR' }, country: { value: 'Greece' } },
    { code: { value: 'HU' }, country: { value: 'Hungary' } },
    { code: { value: 'IT' }, country: { value: 'Italy' } },
    { code: { value: 'JP' }, country: { value: 'Japan' } },
    { code: { value: 'LV' }, country: { value: 'Latvia' } },
    { code: { value: 'LI' }, country: { value: 'Liechtenstein' } },
    { code: { value: 'LT' }, country: { value: 'Lithuania' } },
    { code: { value: 'LU' }, country: { value: 'Luxembourg' } },
    { code: { value: 'MT' }, country: { value: 'Malta' } },
    { code: { value: 'MX' }, country: { value: 'Mexico' } },
    { code: { value: 'NL' }, country: { value: 'Netherlands' } },
    { code: { value: 'NO' }, country: { value: 'Norway' } },
    { code: { value: 'PL' }, country: { value: 'Poland' } },
    { code: { value: 'PT' }, country: { value: 'Portugal' } },
    { code: { value: 'RO' }, country: { value: 'Romania' } },
    { code: { value: 'SK' }, country: { value: 'Slovakia (Slovak Republic)' } },
    { code: { value: 'SI' }, country: { value: 'Slovenia' } },
    { code: { value: 'ES' }, country: { value: 'Spain' } },
    { code: { value: 'SE' }, country: { value: 'Sweden' } },
    { code: { value: 'GB' }, country: { value: 'United Kingdom' } },
    { code: { value: 'US' }, country: { value: 'United States' } },
    { code: { value: 'AF' }, country: { value: 'Afghanistan' } },
    { code: { value: 'AX' }, country: { value: 'Aland Islands' } },
    { code: { value: 'AL' }, country: { value: 'Albania' } },
    { code: { value: 'DZ' }, country: { value: 'Algeria' } },
    { code: { value: 'AS' }, country: { value: 'American Samoa' } },
    { code: { value: 'AD' }, country: { value: 'Andorra' } },
    { code: { value: 'AO' }, country: { value: 'Angola' } },
    { code: { value: 'AI' }, country: { value: 'Anguilla' } },
    { code: { value: 'AQ' }, country: { value: 'Antarctica' } },
    { code: { value: 'AG' }, country: { value: 'Antigua and Barbuda' } },
    { code: { value: 'AR' }, country: { value: 'Argentina' } },
    { code: { value: 'AM' }, country: { value: 'Armenia' } },
    { code: { value: 'AW' }, country: { value: 'Aruba' } },
    { code: { value: 'AT' }, country: { value: 'Austria' } },
    { code: { value: 'AZ' }, country: { value: 'Azerbaijan' } },
    { code: { value: 'BS' }, country: { value: 'Bahamas' } },
    { code: { value: 'BH' }, country: { value: 'Bahrain' } },
    { code: { value: 'BD' }, country: { value: 'Bangladesh' } },
    { code: { value: 'BB' }, country: { value: 'Barbados' } },
    { code: { value: 'BY' }, country: { value: 'Belarus' } },
    { code: { value: 'BE' }, country: { value: 'Belgium' } },
    { code: { value: 'BZ' }, country: { value: 'Belize' } },
    { code: { value: 'BJ' }, country: { value: 'Benin' } },
    { code: { value: 'BM' }, country: { value: 'Bermuda' } },
    { code: { value: 'BT' }, country: { value: 'Bhutan' } },
    { code: { value: 'BO' }, country: { value: 'Bolivia' } },
    { code: { value: 'BA' }, country: { value: 'Bosnia and Herzegovina' } },
    { code: { value: 'BW' }, country: { value: 'Botswana' } },
    { code: { value: 'BV' }, country: { value: 'Bouvet Island' } },
    { code: { value: 'BR' }, country: { value: 'Brazil' } },
    {
      code: { value: 'IO' },
      country: { value: 'British Indian Ocean Territory' },
    },
    { code: { value: 'BN' }, country: { value: 'Brunei Darussalam' } },
    { code: { value: 'BF' }, country: { value: 'Burkina Faso' } },
    { code: { value: 'BI' }, country: { value: 'Burundi' } },
    { code: { value: 'KH' }, country: { value: 'Cambodia' } },
    { code: { value: 'CM' }, country: { value: 'Cameroon' } },
    { code: { value: 'CV' }, country: { value: 'Cape Verde' } },
    { code: { value: 'KY' }, country: { value: 'Cayman Islands' } },
    { code: { value: 'CF' }, country: { value: 'Central African Republic' } },
    { code: { value: 'TD' }, country: { value: 'Chad' } },
    { code: { value: 'CL' }, country: { value: 'Chile' } },
    { code: { value: 'CN' }, country: { value: 'China' } },
    { code: { value: 'CX' }, country: { value: 'Christmas Island' } },
    { code: { value: 'CC' }, country: { value: 'Cocos (Keeling) Islands' } },
    { code: { value: 'CO' }, country: { value: 'Colombia' } },
    { code: { value: 'KM' }, country: { value: 'Comoros' } },
    { code: { value: 'CD' }, country: { value: 'Congo (Kinshasa)' } },
    {
      code: { value: 'CG' },
      country: { value: 'Congo Republic of the Democratic' },
    },
    { code: { value: 'CD' }, country: { value: 'Congo-Brazzaville' } },
    { code: { value: 'CK' }, country: { value: 'Cook Islands' } },
    { code: { value: 'CR' }, country: { value: 'Costa Rica' } },
    { code: { value: 'HR' }, country: { value: 'Croatia (Hrvatska)' } },
    { code: { value: 'CU' }, country: { value: 'Cuba' } },
    { code: { value: 'DJ' }, country: { value: 'Djibouti' } },
    { code: { value: 'DM' }, country: { value: 'Dominica' } },
    { code: { value: 'DO' }, country: { value: 'Dominican Republic' } },
    { code: { value: 'TP' }, country: { value: 'East Timor' } },
    { code: { value: 'EC' }, country: { value: 'Ecuador' } },
    { code: { value: 'EG' }, country: { value: 'Egypt' } },
    { code: { value: 'SV' }, country: { value: 'El Salvador' } },
    { code: { value: 'GQ' }, country: { value: 'Equatorial Guinea' } },
    { code: { value: 'ER' }, country: { value: 'Eritrea' } },
    { code: { value: 'ET' }, country: { value: 'Ethiopia' } },
    {
      code: { value: 'FK' },
      country: { value: 'Falkland Islands (Malvinas)' },
    },
    { code: { value: 'FO' }, country: { value: 'Faroe Islands' } },
    { code: { value: 'FJ' }, country: { value: 'Fiji' } },
    { code: { value: 'GF' }, country: { value: 'French Guiana' } },
    { code: { value: 'PF' }, country: { value: 'French Polynesia' } },
    {
      code: { value: 'TF' },
      country: { value: 'French Southern Territories' },
    },
    { code: { value: 'GA' }, country: { value: 'Gabon' } },
    { code: { value: 'GM' }, country: { value: 'Gambia' } },
    { code: { value: 'GE' }, country: { value: 'Georgia' } },
    { code: { value: 'GH' }, country: { value: 'Ghana' } },
    { code: { value: 'GI' }, country: { value: 'Gibraltar' } },
    { code: { value: 'GL' }, country: { value: 'Greenland' } },
    { code: { value: 'GD' }, country: { value: 'Grenada' } },
    { code: { value: 'GP' }, country: { value: 'Guadeloupe' } },
    { code: { value: 'GU' }, country: { value: 'Guam' } },
    { code: { value: 'GT' }, country: { value: 'Guatemala' } },
    { code: { value: 'GG' }, country: { value: 'Guernsey' } },
    { code: { value: 'GN' }, country: { value: 'Guinea' } },
    { code: { value: 'GW' }, country: { value: 'Guinea-Bissau' } },
    { code: { value: 'GY' }, country: { value: 'Guyana' } },
    { code: { value: 'HT' }, country: { value: 'Haiti' } },
    {
      code: { value: 'HM' },
      country: { value: 'Heard and Mc Donald Islands' },
    },
    { code: { value: 'HN' }, country: { value: 'Honduras' } },
    { code: { value: 'HK' }, country: { value: 'Hong Kong' } },
    { code: { value: 'IS' }, country: { value: 'Iceland' } },
    { code: { value: 'IN' }, country: { value: 'India' } },
    { code: { value: 'ID' }, country: { value: 'Indonesia' } },
    { code: { value: 'IR' }, country: { value: 'Iran (Islamic Republic of)' } },
    { code: { value: 'IQ' }, country: { value: 'Iraq' } },
    { code: { value: 'IE' }, country: { value: 'Ireland' } },
    { code: { value: 'IM' }, country: { value: 'Isle of Man' } },
    { code: { value: 'IL' }, country: { value: 'Israel' } },
    { code: { value: 'CI' }, country: { value: 'Ivory Coast' } },
    { code: { value: 'JM' }, country: { value: 'Jamaica' } },
    { code: { value: 'JE' }, country: { value: 'Jersey' } },
    { code: { value: 'JO' }, country: { value: 'Jordan' } },
    { code: { value: 'KZ' }, country: { value: 'Kazakhstan' } },
    { code: { value: 'KE' }, country: { value: 'Kenya' } },
    { code: { value: 'KI' }, country: { value: 'Kiribati' } },
    { code: { value: 'KP' }, country: { value: 'North Korea' } },
    { code: { value: 'KR' }, country: { value: 'South Korea' } },
    { code: { value: 'KW' }, country: { value: 'Kuwait' } },
    { code: { value: 'KG' }, country: { value: 'Kyrgyzstan' } },
    {
      code: { value: 'LA' },
      country: { value: "Lao People's Democratic Republic" },
    },
    { code: { value: 'LA' }, country: { value: 'Laos' } },
    { code: { value: 'LB' }, country: { value: 'Lebanon' } },
    { code: { value: 'LS' }, country: { value: 'Lesotho' } },
    { code: { value: 'LR' }, country: { value: 'Liberia' } },
    { code: { value: 'LY' }, country: { value: 'Libyan Arab Jamahiriya' } },
    { code: { value: 'MO' }, country: { value: 'Macao S.A.R.' } },
    { code: { value: 'MO' }, country: { value: 'Macau' } },
    { code: { value: 'MK' }, country: { value: 'Macedonia' } },
    { code: { value: 'MG' }, country: { value: 'Madagascar' } },
    { code: { value: 'MW' }, country: { value: 'Malawi' } },
    { code: { value: 'MY' }, country: { value: 'Malaysia' } },
    { code: { value: 'MV' }, country: { value: 'Maldives' } },
    { code: { value: 'ML' }, country: { value: 'Mali' } },
    { code: { value: 'MH' }, country: { value: 'Marshall Islands' } },
    { code: { value: 'MQ' }, country: { value: 'Martinique' } },
    { code: { value: 'MR' }, country: { value: 'Mauritania' } },
    { code: { value: 'MU' }, country: { value: 'Mauritius' } },
    { code: { value: 'YT' }, country: { value: 'Mayotte' } },
    {
      code: { value: 'FM' },
      country: { value: 'Micronesia Federated States of' },
    },
    { code: { value: 'MD' }, country: { value: 'Moldova Republic of' } },
    { code: { value: 'MC' }, country: { value: 'Monaco' } },
    { code: { value: 'MN' }, country: { value: 'Mongolia' } },
    { code: { value: 'ME' }, country: { value: 'Montenegro' } },
    { code: { value: 'MS' }, country: { value: 'Montserrat' } },
    { code: { value: 'MA' }, country: { value: 'Morocco' } },
    { code: { value: 'MZ' }, country: { value: 'Mozambique' } },
    { code: { value: 'MM' }, country: { value: 'Myanmar' } },
    { code: { value: 'NA' }, country: { value: 'Namibia' } },
    { code: { value: 'NR' }, country: { value: 'Nauru' } },
    { code: { value: 'NP' }, country: { value: 'Nepal' } },
    { code: { value: 'AN' }, country: { value: 'Netherlands Antilles' } },
    { code: { value: 'NC' }, country: { value: 'New Caledonia' } },
    { code: { value: 'NZ' }, country: { value: 'New Zealand' } },
    { code: { value: 'NI' }, country: { value: 'Nicaragua' } },
    { code: { value: 'NE' }, country: { value: 'Niger' } },
    { code: { value: 'NG' }, country: { value: 'Nigeria' } },
    { code: { value: 'NU' }, country: { value: 'Niue' } },
    { code: { value: 'NF' }, country: { value: 'Norfolk Island' } },
    { code: { value: 'MP' }, country: { value: 'Northern Mariana Islands' } },
    { code: { value: 'OM' }, country: { value: 'Oman' } },
    { code: { value: 'PK' }, country: { value: 'Pakistan' } },
    { code: { value: 'PW' }, country: { value: 'Palau' } },
    { code: { value: 'PS' }, country: { value: 'Palestinian Territory' } },
    { code: { value: 'PA' }, country: { value: 'Panama' } },
    { code: { value: 'PG' }, country: { value: 'Papua New Guinea' } },
    { code: { value: 'PY' }, country: { value: 'Paraguay' } },
    { code: { value: 'PE' }, country: { value: 'Peru' } },
    { code: { value: 'PH' }, country: { value: 'Philippines' } },
    { code: { value: 'PN' }, country: { value: 'Pitcairn' } },
    { code: { value: 'PR' }, country: { value: 'Puerto Rico' } },
    { code: { value: 'QA' }, country: { value: 'Qatar' } },
    { code: { value: 'RE' }, country: { value: 'Reunion' } },
    { code: { value: 'RU' }, country: { value: 'Russian Federation' } },
    { code: { value: 'RW' }, country: { value: 'Rwanda' } },
    { code: { value: 'BL' }, country: { value: 'Saint Barthelemy' } },
    { code: { value: 'SH' }, country: { value: 'Saint Helena' } },
    { code: { value: 'KN' }, country: { value: 'Saint Kitts' } },
    { code: { value: 'LC' }, country: { value: 'Saint Lucia' } },
    { code: { value: 'MF' }, country: { value: 'Saint Martin (French part)' } },
    { code: { value: 'PM' }, country: { value: 'Saint Pierre and Miquelon' } },
    { code: { value: 'VC' }, country: { value: 'Saint Vincent Grenadines' } },
    { code: { value: 'WS' }, country: { value: 'Samoa' } },
    { code: { value: 'SM' }, country: { value: 'San Marino' } },
    { code: { value: 'ST' }, country: { value: 'Sao Tome and Principe' } },
    { code: { value: 'SA' }, country: { value: 'Saudi Arabia' } },
    { code: { value: 'SN' }, country: { value: 'Senegal' } },
    { code: { value: 'RS' }, country: { value: 'Serbia' } },
    { code: { value: 'SC' }, country: { value: 'Seychelles' } },
    { code: { value: 'SL' }, country: { value: 'Sierra Leone' } },
    { code: { value: 'SL' }, country: { value: 'Sierra Leone' } },
    { code: { value: 'SG' }, country: { value: 'Singapore' } },
    { code: { value: 'SB' }, country: { value: 'Solomon Islands' } },
    { code: { value: 'SO' }, country: { value: 'Somalia' } },
    { code: { value: 'ZA' }, country: { value: 'South Africa' } },
    {
      code: { value: 'GS' },
      country: { value: 'South Georgia and the South Sandwich Islands' },
    },
    { code: { value: 'LK' }, country: { value: 'Sri Lanka' } },
    { code: { value: 'SD' }, country: { value: 'Sudan' } },
    { code: { value: 'SR' }, country: { value: 'Suriname' } },
    {
      code: { value: 'SJ' },
      country: { value: 'Svalbard and Jan Mayen Islands' },
    },
    { code: { value: 'SZ' }, country: { value: 'Swaziland' } },
    { code: { value: 'CH' }, country: { value: 'Switzerland' } },
    { code: { value: 'SY' }, country: { value: 'Syrian Arab Republic' } },
    { code: { value: 'TW' }, country: { value: 'Taiwan' } },
    { code: { value: 'TJ' }, country: { value: 'Tajikistan' } },
    { code: { value: 'TZ' }, country: { value: 'Tanzania' } },
    { code: { value: 'TH' }, country: { value: 'Thailand' } },
    { code: { value: 'TG' }, country: { value: 'Togo' } },
    { code: { value: 'TK' }, country: { value: 'Tokelau' } },
    { code: { value: 'TO' }, country: { value: 'Tonga' } },
    { code: { value: 'TT' }, country: { value: 'Trinidad and Tobago' } },
    { code: { value: 'TN' }, country: { value: 'Tunisia' } },
    { code: { value: 'TR' }, country: { value: 'Turkey' } },
    { code: { value: 'TM' }, country: { value: 'Turkmenistan' } },
    { code: { value: 'TC' }, country: { value: 'Turks and Caicos Islands' } },
    { code: { value: 'TV' }, country: { value: 'Tuvalu' } },
    { code: { value: 'UG' }, country: { value: 'Uganda' } },
    { code: { value: 'UA' }, country: { value: 'Ukraine' } },
    { code: { value: 'AE' }, country: { value: 'United Arab Emirates' } },
    {
      code: { value: 'UM' },
      country: { value: 'United States Minor Outlying Islands' },
    },
    { code: { value: 'UY' }, country: { value: 'Uruguay' } },
    { code: { value: 'USAF' }, country: { value: 'US Armed Forces' } },
    { code: { value: 'UZ' }, country: { value: 'Uzbekistan' } },
    { code: { value: 'VU' }, country: { value: 'Vanuatu' } },
    {
      code: { value: 'VA' },
      country: { value: 'Vatican City State (Holy See)' },
    },
    { code: { value: 'VE' }, country: { value: 'Venezuela' } },
    { code: { value: 'VN' }, country: { value: 'Vietnam' } },
    { code: { value: 'VG' }, country: { value: 'Virgin Islands (British)' } },
    { code: { value: 'VI' }, country: { value: 'Virgin Islands (US)' } },
    { code: { value: 'WF' }, country: { value: 'Wallis and Futuna Islands' } },
    { code: { value: 'EH' }, country: { value: 'Western Sahara' } },
    { code: { value: 'YE' }, country: { value: 'Yemen' } },
    { code: { value: 'ZM' }, country: { value: 'Zambia' } },
    { code: { value: 'ZW' }, country: { value: 'Zimbabwe' } },
  ]
  // CardCurrencySupportedCountries returns an HTML line for each entry in the countries array.
  // Each line includes the country name,
  // followed by the country code in code format surrounded by parenthesis,
  // and a key index for the position of that country.

  return (
    <div>
      <h3>Supported countries</h3>
      <ul>
        {countries.map(({ code, country }, index) => (
          <li key={index}>
            {country.value} (<code>{code.value}</code>)
          </li>
        ))}
      </ul>
    </div>
  )
}

export default CardCurrencySupportedCountries
